import styled from "@emotion/styled";
import { Box, Button } from "@mui/material";
import FeaturedVideoOutlinedIcon from "@mui/icons-material/FeaturedVideoOutlined";

export const VideoContentWrapper = styled(Box)`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 10px;
`;

export const VideoContentClickable = styled(Button)`
  padding: 0;
`;

export const VideoContentContainer = styled(Box)`
  width: 100%;
  height: 100%;
  position: relative;
`;

export const VideoContentOverlay = styled(Box)`
  position: absolute;
  top: 2px;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 95%;
  color: #fff;
`;

export const VideoIcon = styled(FeaturedVideoOutlinedIcon)`
  top: 0;
  left: 4px;
  position: absolute;
`;
